import { render, staticRenderFns } from "./MecanizadoSubTab.vue?vue&type=template&id=51bc0244&"
import script from "./MecanizadoSubTab.vue?vue&type=script&lang=js&"
export * from "./MecanizadoSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports